(ns hai.web-app.add-menu
  "Task add modal.

  Mobile drives an add bottom-sheet (hai.home.mobile.add-sheet) whose task
  tile opens the modal defined here, as does the desktop universal
  \"Add anything…\" bar; note creation goes through the expanded editor
  (hai.notes.create) on every surface."
  (:require
   [hai.entity.draft :as draft]
   [hai.tasks.data :as tasks-data]
   [hai.tasks.form :as form]
   [hai.tasks.mini-app :as tasks-mini-app]
   [hai.tasks.modal :as task-modal]
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [<s >e defevent defsub]]
   [hai.web-app.routing :as routing]))

;; ---------------------------------------------------------------------------
;; Task events
;;
;; Task creation reuses hai.tasks.data/create, which persists via the
;; task/create resolver and prepends to :hai.tasks.data/list — the same
;; key the Desktop card subscribes to and reloads on every visit. So a task
;; added from here shows up wherever tasks are shown, no extra refresh.
;; ---------------------------------------------------------------------------

(def draft-id
  "The draft behind the ＋ menu's Add-a-task modal."
  ::draft)

(defsub ::task-modal-open? [db]
  (get db ::task-modal-open? false))

;; `title` seeds the composer for a host that already asked for one — the
;; universal bar hands over whatever was typed into it, and none of it is filed,
;; so the modal's Save is there from the first render.
(defevent ::open-task-modal [db title]
  (-> db
      (assoc ::task-modal-open? true)
      (draft/seed draft-id (form/from-task {:task/title title}
                                           (tasks-data/default-urgency db)))))

;; The draft goes with the modal: reopening always starts fresh.
(defevent ::close-task-modal [db _]
  (-> db
      (dissoc ::task-modal-open?)
      (draft/discard draft-id)))

;; ---------------------------------------------------------------------------
;; Task modal
;; ---------------------------------------------------------------------------

(defn task-modal
  "Add a task, as the Tasks card adds one ([[tasks-mini-app/composer-view]]),
   in a modal: Share, Cancel and Save in its header, Cancel closing it — at
   once with nothing typed, asking first otherwise — and Save closing it once
   the task is filed. Escape in a field is the field's; elsewhere Escape, and
   a press outside, close it as a dialog."
  []
  (let [open? @(<s [::task-modal-open?])
        saving? (= :start @(<s [:fetch/state ::create]))
        close! (fn [] (>e [::close-task-modal]))]
    [c/DialogRoot
     {:open open?
      :onOpenChange (fn [opening?]
                      (when-not opening?
                        (close!)))}
     [c/DialogContent {:align "start" :max-width "480px" :style task-modal/bare-dialog-panel
                       :onEscapeKeyDown task-modal/keep-escape-in-fields}
      [c/DialogTitle {:style task-modal/visually-hidden} "Add a task"]
      [c/DialogDescription {:style task-modal/visually-hidden} "Create a new task."]
      ;; Mounted only while open, over a draft opening the modal seeds. No
      ;; assignee is staged: an unpicked composer means the creator, same as
      ;; everywhere.
      (when open?
        [task-modal/modal-card
         [tasks-mini-app/composer-view
          {:draft-id draft-id
           :saving? saving?
           :show-hint? true
           :on-save (fn [task]
                      (>e [::tasks-data/create (assoc task
                                                      :request-id ::create
                                                      :task-link {:href-fn #(routing/href :tasks/detail {:task/uuid %})
                                                                  :target routing/link-target}
                                                      :success-fx [[:dispatch [::close-task-modal]]])]))
           :on-close close!}]])]]))

(defn modals []
  [:<>
   [task-modal]])
